import React from 'react'
import { useSelector } from 'react-redux'

import i18n from '~/i18n'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'

import * as styles from './index.module.scss'

const AutomationThemeCard = ({ type, theme, saving = false, onClick }) => {
    const site = useSelector((state) => state.siteMaster)
    const isScratch = type === 'scratch'
    const chipValue = theme?.Application?.appName || theme?.featureChipText

    const RenderIcon = () => {
        if (theme?.Application?.appLogoUri) {
            return <Avatar src={theme.Application.appLogoUri} style={{ height: 32, width: 32 }} />
        }
        if (theme?.icon?.startsWith('icon-')) {
            return (
                <div className={styles.cardIcon} style={{ color: site.colours.$primary }}>
                    <span className={theme.icon} />
                </div>
            )
        }
        if (theme?.icon) {
            return <Icons icon={theme.icon} circle={true} style={{ height: 32, width: 32 }} />
        }

        return <Icons icon='pencil' circle={true} style={{ height: 32, width: 32 }} />
    }

    let classes = styles.card

    let description = ''
    if (isScratch) {
        description = i18n.t('automation:overview.createBrandNewAutomation')
    } else if (theme.description && theme.description.indexOf('.') > -1) {
        description = theme.description
    } else {
        description = i18n.t('automation:themes.' + theme.id + '_desc', theme.description)
    }

    return (
        <div className={classes} onClick={() => onClick(isScratch ? 'scratch' : 'theme', theme)}>
            <RenderIcon />
            {saving && (
                <div className={styles.cardSaving}>
                    <LoadingIcons />
                </div>
            )}
            <div>
                {chipValue && (
                    <div className={styles.cardLabel}>
                        <SquareChip value={chipValue} />
                    </div>
                )}
                <div className={styles.cardTitle}>
                    {isScratch
                        ? i18n.t('automation:overview.frmScratch')
                        : i18n.t('automation:themes.' + theme.id + '_name', theme.name)}
                </div>
                <div className={styles.cardDescription}>{description}</div>
            </div>
        </div>
    )
}

export default AutomationThemeCard
